import { render, staticRenderFns } from "./GalleryView.vue?vue&type=template&id=22497e91&"
import script from "./GalleryView.vue?vue&type=script&lang=js&"
export * from "./GalleryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports